import styles from './TournamentNavigationItem.module.css';
import { NAMESPACES } from '../../../constants/namespaces';
import { Local } from '../../Local/Local';
import { Icon } from '@modulor/react';
import { ButtonWithAnalytics } from '../../Button/Button';
import SeoLink from '../../SeoLink/SeoLink';
import { useTournamentLobbyRedirectCallback } from '../../../hooks/useTournamentLobbyRedirect';
import { useIsDesktopLayout } from '../../../hooks/useIsDesktopLayout';

const TournamentNavigationItem = () => {
  const isDesktop = useIsDesktopLayout();
  const redirectToTournamentsLobby = useTournamentLobbyRedirectCallback();

  return (
    <li className={styles.item}>
      <SeoLink>
        {/* @ts-ignore*/}
        <ButtonWithAnalytics
          className={styles.tournaments}
          onClick={redirectToTournamentsLobby}
        >
          <Icon name="cup_outlined" className={styles.icon} />
          <span className={styles.title}>
            <Local namespace={NAMESPACES.PAGES}>Tournaments</Local>
          </span>
          {!isDesktop && (
            <Icon name="chevron_right" className={styles.chevron} />
          )}
        </ButtonWithAnalytics>
      </SeoLink>
    </li>
  );
};

export default TournamentNavigationItem;
